import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/w/$workspace/automations/moderation")({ component: () => <Outlet /> })
